Wee.fn.make('commerce', {
	_construct: function() {
		$.view.addHelper('currency', function() {
			var val = this.val,
				negative = val < 0;

			if (negative) {
				val = Math.abs(val);
			}

			val = '$' + (Math.round(val * 100) / 100).toFixed(2);

			if (negative) {
				val = '-' + val;
			}

			return val;
		});
	},

	/**
	 * Observe cart data set
	 *
	 * @param {object} options
	 * @param {(Array|function|string)} [options.onChange] - callback on data set change
	 */
	init: function(options) {
		var onChange = options.onChange;

		$.observe('cart', function(data) {
			var app = $.app,
				cartTotals = app.cartTotals,
				miniCart = app.miniCart;

			if (miniCart) {
				miniCart.$set(data);
			}

			if (cartTotals) {
				cartTotals.$set(data);
			}

			if (onChange) {
				onChange(data);
			}
		}, {
			recursive: true,
			scope: this
		});
	}
}, {
	/**
	 * Post method for fetch request
	 *
	 * @private
	 * @param {object} options - includes all options available to $.fetch.request
	 */
	post: function(options) {
		$.fetch.request($.extend({
			url: $.routes.uri().path,
			method: 'post',
			json: true
		}, options));
	},

	/**
	 * Transform cart data set with additional properties
	 *
	 * @private
	 * @param {object} cart
	 */
	transform: function(cart) {
		cart.notEmpty = ! cart.isEmpty;
		cart.itemSubtotal = parseFloat(cart.itemTotal) - cart.totalDiscount - cart.totalShippingCost - cart.totalTax;

		return cart;
	}
});